<template>
  <v-container grid-list-xl class="pa-5">
    <v-alert
      v-if="is_premium"
      dense text
      class="body-2 mb-5"
      type="info"
    >
      Berikut ini merupakan hari daftar libur pengguna, silakan
      <b>klik tombol tambah (+) untuk menambahkan</b> hari libur pengguna.
    </v-alert>

    <m-card-list
      two-line
      title="Hari Libur"
      label-cari="Cari Hari Libur"
      :add="isCan(`hari-libur.${keyAkses}store`)"
      edit
      search
      :items="items"
      :headers="headers"
      refresh
      @refresh="load"
      :page="page"
      footer
      @search="
            search => {
              textSearch = search;
              load();
            }
          "
      @change:page="
            pg => {
              cp = pg;
              load();
            }
          "
      @add="add"
    >
      <template v-slot:action_tools>
        <v-btn
          v-if="isCan('hari-libur.sinkron') && is_simpatika"
          class="mx-1"
          color="orange"
          dark
          depressed
          @click="onSync"
        >
          <v-icon left>mdi-sync</v-icon>
          Sinkronisasi
        </v-btn>
      </template>
      <template v-slot:items="{ props, item }">
        <tr v-if="$vuetify.breakpoint.smAndUp">
          <td>{{ pVal(item, "tanggal") | toSDN }}</td>
          <td>{{ pVal(item, "tanggal") | toDo }}</td>
          <td>
            <template v-if="item.k_hari_libur">
              {{ Number(item.k_hari_libur) === 1 ? 'Libur Nasional' : 'Cuti Bersama' }}
            </template>
          </td>
          <td>{{ pVal(item, "keterangan") }}</td>
          <td>
            <m-menu
              v-if="(isCan(`hari-libur.${keyAkses}update`) ||
                     isCan(`hari-libur.${keyAkses}destroy`)) &&
                     Number(item.is_sistem) === 0
                   "
              left
              style="float:right"
              :items="more_menu"
              :object="item"
            />
          </td>
        </tr>
        <tr v-else>
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header mr-2">Tanggal</div>
            <div class="v-data-table__mobile-row__cell">
              {{ pVal(item, "tanggal") | toSDN }}
            </div>
          </td>
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header mr-2">Hari</div>
            <div class="v-data-table__mobile-row__cell">
              {{ pVal(item, "tanggal") | toDo }}
            </div>
          </td>
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header mr-2">
              Keterangan
            </div>
            <div class="v-data-table__mobile-row__cell">
              {{ pVal(item, "keterangan") }}
            </div>
          </td>
          <td v-if="more_menu.length" class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header mr-2">Aksi</div>
            <div class="v-data-table__mobile-row__cell">
              <m-menu
                v-if="(isCan(`hari-libur.${keyAkses}update`) ||
                       isCan(`hari-libur.${keyAkses}destroy`)) &&
                       Number(item.is_sistem) === 0
                     "
                left
                style="float:right"
                :items="more_menu"
                :object="item"
              />
            </div>
          </td>
        </tr>
      </template>
    </m-card-list>
    <ChangeDlg ref="dlg" />
  </v-container>
</template>

<script>
import { isCan } from "@/tools";
import ChangeDlg from "../components/Form.vue";
import BlockCard from "@/components/BlockCard";

export default {
  components: {
    ChangeDlg,
    BlockCard
  },
  data() {
    return {
      items: [],
      textSearch: null,
      page: null,
      cp: 1,
      headers: [
        { text: "Tanggal", align: "left", value: "tanggal" },
        { text: "Hari", align: "left", value: "hari" },
        { text: "Jenis Hari Libur", align: "left", value: "jenis" },
        { text: "Keterangan", align: "left", value: "keterangan" },
        { text: "", align: "left", sortable: false }
      ],
      stat: {
        jenis_kelamin: { data: [], legend: [] },
        usia: { data: [], legend: [] }
      },
      more_menu: [
        {
          title: "Ubah",
          click: (i, o) => this.edit(o),
          check: () => isCan(`hari-libur.${this.keyAkses}update`)
        },
        {
          title: "Hapus",
          click: (i, o) => this.hapus(o),
          check: () => isCan(`hari-libur.${this.keyAkses}destroy`)
        }
      ]
    };
  },
  computed: {},
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.$store
        .dispatch("hariLibur/get", {
          organisasi_id: this.organisasi_id || this.tenant_id,
          params: {
            page: this.cp,
            keyword: this.textSearch
          }
        })
        .then(res => {
          this.page = res.data;
          this.items = res.data.data;
        })
        .catch(e => e);
    },
    add() {
      this.$refs.dlg.open().then(() => {
        this.load();
      });
    },
    edit(item) {
      this.$refs.dlg.open(item).then(() => {
        this.load();
      });
    },
    hapus(item) {
      this.$confirmDanger(
        `<div class="px-5 mx-1 mt-2 py-2 mb-4 pa-1 row red lighten-5 rounded red--text">

            <i class="v-icon v-alert__icon mdi mdi-information red--text"></i>

            <div class="col py-0 body-2">
            Pastikan Anda benar-benar mengerti apa yang Anda lakukan.
          </div>
        </div>

        Apakah Anda yakin akan menghapus data ini ?<br>
        <div class="mt-2 title grow text-center">
           ${item.keterangan}<br>
        </div>

      `
      )
        .then(() =>
          this.$store.dispatch("hariLibur/drop", {
            organisasi_id: this.organisasi_id || this.tenant_id,
            hari_libur_id: item.hari_libur_id
          })
        )
        .then(() => {
          this.$info("Data berhasil dihapus");
        })
        .then(() => this.load())
        .catch(e => e);
    },
    onSync() {
      this.$store.dispatch("hariLibur/sinkron", {
        organisasi_id: this.organisasi_id,
      })
        .then(() => {
          this.$success("Aksi sinkron berhasil dilakukan")
          this.load()
        })
    }
  }
};
</script>
